<template>
	<div class="container">
		<div class="main_box">
			<div class="block_1">
				<div class="block_1_main">
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="tit_box"
					>
						<div class="tit">荣誉资质</div>
						<div class="txt">宝瑞源生物技术(北京)有限公司自建立之初，一直以科研为基础，奉献创造价值为信念，获得了行业内多项专利授权和资质证书</div>
					</div>
					<div v-if="honorList.length > 0" class="swiper_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<swiper ref="myswiper" :options="swiperOptions">
							<swiper-slide v-for="(value, index) in honorList" :key="index" class="slide">
								<img :src="value.thumb">
								<div class="tit">{{ value.title }}</div>
							</swiper-slide>
						</swiper>
					</div>
				</div>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";  //轮播图插件
import "swiper/dist/css/swiper.css";  //轮播图插件
import { ImagePreview } from 'vant';  //图片放大
var vm = null;
export default {
	components:{
		swiper,
		swiperSlide
	},
	data() {
		return {
			isLoading: true,  //界面loading
			swiperOptions: {  //荣誉资质轮播
				loop: true,
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: false
				},
				slidesPerView: 3,
				spaceBetween: 0,
				centeredSlides: true,
				effect: 'coverflow',
				coverflowEffect: {
					slideShadows: false, // 页面阴影效果
					rotate: 0, // 旋转的角度
					stretch: 0, // 拉伸   图片间左右的间距和密集度，越大靠得越近
					depth: 800, // 深度   切换图片间上下的间距和密集度，值越大z轴距离越远，看起来越小。
					modifier: 1, // 修正值 该值越大前面的效果越明显
				},
				/* pagination: {
				  el: '.swiper-pagination', //获取元素
				  clickable: true, //可根据圆点切换
				}, */
				on: {
					click: function () {
						vm.showImg(this.realIndex);
					}
				}
			},
			honorList: [
				{ id: 2, title: '北京市“专精特新”中小企业', thumb: require('@/assets/img_public/about/honor/honor02.webp') },
				{ id: 3, title: '中关村高新技术企业', thumb: require('@/assets/img_public/about/honor/honor03.webp') },
				{ id: 5, title: '9001 质量管理体系认证证书', thumb: require('@/assets/img_public/about/honor/honor05.webp') },
				{ id: 4, title: '高新技术企业', thumb: require('@/assets/img_public/about/honor/honor04.webp') },
				{ id: 1, title: 'ISO 13485', thumb: require('@/assets/img_public/about/honor/honor01.webp') }
			],
		}
	},
	created(){
		let that = this;
		vm = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//图片放大
		showImg(value) {
			let that = this;
			let url = that.honorList[value].thumb;
			ImagePreview({
				closeable: true,
				showIndicators: false,
				showIndex: false,
				images: [url],
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	//块1
	.block_1{
		background-color: #F7F8FA;
		.block_1_main{
			width: 1200px;
			margin: 0 auto;
			padding-bottom: 100px;
			.swiper_box{
				padding-top: 40px;
				.tit{
					padding-top: 40px;
					text-align: center;
					font-size: 28px;
				}
				img{
					width: 100%;
				}
			}
			.tit_box{
				padding: 0px 0 20px 0;
				text-align: center;
				.txt{
					padding-top: 20px;
					font-size: 18px;
				}
				.tit{
					font-size: 44px;
					font-weight: bold;
				}
			}
		}
	}
}
</style>